<template>
    <span v-if="currentValue || editonly !== undefined">
        <span v-if="showEditor">
            <input ref="el" type="text" v-model="newValue" @blur="change" @keydown.enter="change" @keydown.esc="cancel"/>
        </span>
        <span v-else @click="toggleEdit()" style="cursor: pointer" :class="{modified: modified}">
            for {{newValue}}
        </span>
    </span>
</template>

<script>
    export default {
      data () {
        return {
          newValue: '',
          editing: false,
        }
      },
      props: {
        currentValue: null,
        readonly: undefined,
        editonly: undefined
      },
      created () {
        this.newValue = this.currentValue
      },
      computed: {
        modified () {
          return this.currentValue !== this.newValue
        },
        showEditor () {
          return (
            (this.readonly === undefined) && (
              this.editing
              || this.newValue === 0
              || this.newValue === '0'
              || this.newValue === null
              || this.newValue === ''
              || this.newValue === undefined
              || (this.editonly !== undefined)
            )
          )
        },
      },
      methods: {
        toggleEdit () {
          if (this.readonly !== undefined) {
            this.editing = false
          } else {
            this.editing = true
            this.$nextTick(() => this.$refs.el.focus())
          }
        },
        clear () {
          this.newValue = ''
        },
        change () {
          if (this.editing || this.editonly !== undefined) {
            this.$emit('change', this.newValue)
            this.editing = false
          }
        },
        cancel () {
          this.editing = false
          this.newValue = this.currentValue
        }
      },
    }
</script>

<style scoped lang="less">
    .guest-name {
      font-weight: bold;
    }
</style>